import { Actions, type PublishData } from '@storeOld/reducers/publish/types'

export const publish = (
  state: PublishData | null = null,
  { type, payload }: { type: Actions; payload: any }
) => {
  switch (type) {
    case Actions.SET_PUBLISH_DATA: {
      return payload
    }
    case Actions.REMOVE_PUBLISH_DATA: {
      return payload
    }
    case Actions.SET_PRESET_NAME: {
      return {
        ...state,
        presetName: payload,
      }
    }
    case Actions.SET_FONT: {
      return {
        ...state,
        fontType: payload,
      }
    }
    case Actions.SET_CONTENT: {
      return {
        ...state,
        contentType: payload,
      }
    }
    case Actions.SET_BG_COLOR: {
      return {
        ...state,
        bgColor: payload,
      }
    }
    case Actions.SET_PAGE_PREVIEW: {
      return {
        ...state,
        pagePreview: payload,
      }
    }
    case Actions.SET_TAB_INFO: {
      return {
        ...state,
        tab: payload,
      }
    }
    case Actions.SET_SEARCH_ENGINE: {
      return {
        ...state,
        searchEngine: payload,
      }
    }
    case Actions.SET_BRANDING: {
      return {
        ...state,
        withBranding: payload,
      }
    }
    default: {
      return state
    }
  }
}
